import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import React, { FC } from "react";
import { css } from "styled-components";
import ProductBrand from "@insite/content-library/Components/ProductBrand";
import Typography from "@insite/mobius/Typography";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { StyledButton } from "@insite/mobius/Clickable";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import ADIColors from "@NA/Utils/ADIColors";

interface OwnProps {
    extendedStyles?: ADIStickyCartDescriptionStyles;
}

type Props = OwnProps & HasProduct;

export interface ADIStickyCartDescriptionStyles {
    container?: GridContainerProps;
    productTitleText?: InjectableCss;
    productNumberText?: InjectableCss;
}

export const adiStickyCartDescriptionStyles: ADIStickyCartDescriptionStyles = {
    container: {
        css: css`
            >${StyledButton}{
                >${TypographyStyle}{
                    font-size: 12px;
                    color: ${getColor("primary")};
                    ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    css`
                        font-size: 10px;
                        color: ${ADIColors.blue5} !important;
                        `,
                    null,
                ], "max")}
                }
            }
         ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css` padding-left: 35px; `,
                    null,
                    null,
                ])}        

        `
    },
    productTitleText: {
        css: css`
            font-size: 18px;
            font-weight: 600;
            line-height: 1.22;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                font-size: 12px;
                line-height: 1.17;`,
                    null,
                    null,
                ], "max")}
        `
    },
    productNumberText: {
        css: css`
            font-size: 12px;
            color: ${getColor("text.accent")};
            margin-top: 5px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    css`display: none;`,
                    null,
                    null,
                    null,
                ], "max")}  
        `
    }
};

const ADIStickyCartDescription: FC<Props> = ({
    product,
    extendedStyles
}) => {
    const [styles] = React.useState(() => mergeToNew(adiStickyCartDescriptionStyles, extendedStyles));
    
    return (
        <StyledWrapper {...styles.container}>
            {product.brand && (
                <ProductBrand brand={product.brand} />
            )}
            <Typography as="p" {...styles.productTitleText}>{product.productTitle}</Typography>
            <Typography as="p" {...styles.productNumberText}>{product.detail?.modelNumber}&nbsp;|&nbsp;{product.productNumber}</Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ADIStickyCartDescription),
    definition: {
        group: "Common",
        displayName: "ADI Sticky Cart Description",
    },
};

export default widgetModule;
